<template>
	<div class="container">
		<div class="privacy">
			<div class="policy">
				<div class="policy-title">联系播聘 Contact us</div>
				<div class="policy-content">
					<div class="policy-c-view">
						<h3>播聘深圳总部</h3>
						<br>
						<p>地址:深圳市南山区高新科技园高新南一道6号TCL大厦A座7楼</p>
						<p>邮编:518057</p>
						<p>客服电话: 0755-8254 0116</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:`ShowPrivacyPolicy`
	}
</script>

<style scoped="scoped">
	@import url("./show-privacy-policy.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-privacy-policy/show-privacy-policy.vue